import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {cssTheme} from '../../../themes'

export const FieldWrapperStyles = css`
  gap: ${cssTheme.layout.spacing.s200};
  display: flex;
  flex-direction: column;
  width: 100%;
  /* This padding prevents the outline from being cut off when the input is focused */
  padding: 1px;
`

export const FieldStyles = css`
  align-items: center;
  background: ${cssTheme.colors.input.background.default};
  border-radius: ${cssTheme.layout.radius.md};
  border: 1px solid ${cssTheme.colors.input.border.default};
  display: flex;
  gap: ${cssTheme.layout.spacing.s250};
  height: 48px;
  padding: 0 ${cssTheme.layout.spacing.s400};

  &:focus-within,
  &.__isFilled {
    .label {
      ${cssTheme.typography.bodyXS};

      background: ${cssTheme.colors.background.neutral.c000};
      padding: 0 ${cssTheme.layout.spacing.s200};
      transform: translateY(-19px) translateX(-4px);
      height: auto;
    }

    /* Hack to vertically align the label with the Field on mobile Safari */
    @supports (-webkit-touch-callout: none) {
      .label {
        transform: translateY(-19px) translateX(-4px);
      }
    }
  }

  &:focus-within {
    outline: 1px solid ${cssTheme.colors.border.interactive.c800};
    border-color: ${cssTheme.colors.border.interactive.c800};
  }

  &:focus-within,
  &:not(.__isDisabled):not(.__isInvalid).__isFilled {
    .label {
      color: ${cssTheme.colors.input.text.default};
    }
  }

  &.__isInvalid {
    &:not(:focus-within) {
      border-color: ${cssTheme.colors.input.border.error};
      &.__isFilled {
        .label {
          color: ${cssTheme.colors.input.caption.error};
        }
      }
    }
  }

  &:not(.__isDisabled):not(.__isInvalid):not(:focus-within):hover {
    border-color: ${cssTheme.colors.input.border.hover};
  }

  &.__isDisabled {
    background: ${cssTheme.colors.input.background.disabled};
    border-color: ${cssTheme.colors.input.border.disabled};

    .label {
      background: linear-gradient(
        to top,
        ${cssTheme.colors.input.background.disabled} 50%,
        transparent 50%
      );
      color: ${cssTheme.colors.input.text.disabled};
    }
  }

  input,
  select,
  textarea {
    color: ${cssTheme.colors.input.text.default};
    appearance: none;
    -webkit-appearance: none;
    padding: 0;
    ::-webkit-search-cancel-button {
      display: none;
    }

    &::placeholder {
      color: ${cssTheme.colors.input.label.default};
      text-transform: none;
    }
  }
`

export const InputGroupStyles = css`
  position: relative;
  width: 100%;
`

export const InputTextStyles = css`
  ${cssTheme.typography.bodyM};

  display: block;
  border: none;
  color: ${cssTheme.colors.input.text.default};
  outline: none;
  width: 100%;

  &:disabled {
    background: ${cssTheme.colors.input.background.disabled};
    color: ${cssTheme.colors.input.text.disabled};
  }

  &::placeholder {
    color: ${cssTheme.colors.input.label.default};
  }
`

export const InputLabel = styled.span`
  ${cssTheme.typography.bodyM};

  /* Hack to vertically center the label on mobile Safari */
  display: -webkit-inline-box;
  -webkit-box-pack: center;
  -webkit-box-align: center;

  color: ${cssTheme.colors.input.label.default};
  left: 0;
  position: absolute;
  top: 0;
  height: 100%;
  transition:
    top 0.2s ease,
    left 0.2s ease,
    font-size 0.2s ease,
    color 0.2s ease,
    padding 0.2s ease,
    transform 0.2s ease,
    height 0.2s ease;

  .asterisk {
    color: ${cssTheme.colors.content.accent.c600};
  }
`

export const CaptionStyles = css`
  ${cssTheme.typography.bodyXS};

  padding: 0 ${cssTheme.layout.spacing.s400};
  color: ${cssTheme.colors.input.caption.default};

  &.__isInvalid {
    color: ${cssTheme.colors.input.caption.error};
  }

  &.__isDisabled {
    color: ${cssTheme.colors.input.caption.disabled};
  }
`
